import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { LoaderSmall } from '../../components';
import CustomerAvatar from '../../components/Users/UserAvatar'

const UserTile = (props) => {
  const loading = props.loading || false;
  const press = () => {
    if(props.select && typeof props.select === 'function'){
      props.select(props.user);
    }
  }
  return (
    <TouchableOpacity activeOpacity={0.6} style={[styles.contractorTile, CS.rowContainer]} onPress={press}>
      <View style={styles.contractorTileInner}>
        <View style={styles.avatarContainer}>
          <CustomerAvatar userId={props.user.id} avatar={props.user.avatar} size='medium' />
        </View>
        <View style={CS.flex}>
          <Text style={[CS.mediumText, CS.boldText, CS.lightText]}>{props.user.first_name + ' ' + props.user.last_name}</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 5, marginBottom: 3 }]}>{props.user.mobile || props.user.home}</Text>
          <Text style={[CS.smallText, CS.lightBlueText]}>{props.user.email_address}</Text>
        </View>
      </View>
      <LoaderSmall loading={loading} style={{ borderRadius: 10 }} />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  contractorTile: {
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: Colors.textInputBackground,
  },
  contractorTileInner: {
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatarContainer: {
    // borderRadius: 100,
    // overflow: 'hidden',
    // borderStyle: 'solid',
    // borderWidth: 5,
    // borderColor: Colors.lightBlue2,
    marginRight: 15,
  },
  avatar: {
    width: 80,
    height: 80,
  },
})

export default UserTile;